import "./App.css";

import Sans from "@sans-service-tier/sdk";
import { configure } from "@sans-service-tier/sdk-web";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";

import App from "./App";

// Init the SANS SDK (this is needed here and in App.tsx to preserve header...)
configure(Sans, {
  window,
  initialEnvironment: {
    development: { uri: process.env.REACT_APP_RC_URI },
  },
});

ReactDOM.createRoot(document.getElementById("app") as HTMLElement).render(
  <BrowserRouter basename="/workbook">
    <App />
  </BrowserRouter>,
);
